"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ProductsMultipleView = exports.ESDBProductPlaceHolder = undefined;

var _dec, _class, _class2, _temp;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChevronLeftIcon = require("mdi-react/ChevronLeftIcon");

var _ChevronLeftIcon2 = _interopRequireDefault(_ChevronLeftIcon);

var _ChevronRightIcon = require("mdi-react/ChevronRightIcon");

var _ChevronRightIcon2 = _interopRequireDefault(_ChevronRightIcon);

var _GridIcon = require("mdi-react/GridIcon");

var _GridIcon2 = _interopRequireDefault(_GridIcon);

var _PageFirstIcon = require("mdi-react/PageFirstIcon");

var _PageFirstIcon2 = _interopRequireDefault(_PageFirstIcon);

var _PageLastIcon = require("mdi-react/PageLastIcon");

var _PageLastIcon2 = _interopRequireDefault(_PageLastIcon);

var _ViewListIcon = require("mdi-react/ViewListIcon");

var _ViewListIcon2 = _interopRequireDefault(_ViewListIcon);

var _nodeToolbox = require("@esnpm/node-toolbox");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _forms = require("@esnpm/forms");

var _reactToolbox = require("@esnpm/react-toolbox");

var _translate = require("@esnpm/translate");

var _reactLayoutComponents = require("react-layout-components");

var _reactRedux = require("react-redux");

var _esdb = require("../../actions/esdb");

var _trProductsMultipleView = require("../../translations/trProductsMultipleView");

var _reactStickyEl = require("react-sticky-el");

var _reactStickyEl2 = _interopRequireDefault(_reactStickyEl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = require("classnames");

var ESDBProductPlaceHolder = exports.ESDBProductPlaceHolder = function (_React$Component) {
	_inherits(ESDBProductPlaceHolder, _React$Component);

	function ESDBProductPlaceHolder() {
		_classCallCheck(this, ESDBProductPlaceHolder);

		return _possibleConstructorReturn(this, (ESDBProductPlaceHolder.__proto__ || Object.getPrototypeOf(ESDBProductPlaceHolder)).apply(this, arguments));
	}

	_createClass(ESDBProductPlaceHolder, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: "ProductPlaceHolder" },
				this.props.SKU
			);
		}
	}]);

	return ESDBProductPlaceHolder;
}(_react2.default.Component);

var ProductsMultipleView = exports.ProductsMultipleView = (_dec = (0, _reactRedux.connect)(function (state) {
	return {
		productsMultipleView: state.productsMultipleView
	};
}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_React$Component2) {
	_inherits(ProductsMultipleView, _React$Component2);

	function ProductsMultipleView(props) {
		_classCallCheck(this, ProductsMultipleView);

		var _this2 = _possibleConstructorReturn(this, (ProductsMultipleView.__proto__ || Object.getPrototypeOf(ProductsMultipleView)).call(this, props));

		_this2.state = {
			selectedProducts: [],
			cuttedProducts: [],
			onContextMenuProduct: null
		};
		return _this2;
	}

	_createClass(ProductsMultipleView, [{
		key: "addSelectedProduct",
		value: function addSelectedProduct(sku) {
			var selectedProducts = this.state.selectedProducts;
			var ret = void 0;
			if (selectedProducts.indexOf(sku) == -1) {
				ret = selectedProducts.concat([sku]);
			}

			this.setSelectedProducts(ret);
		}
	}, {
		key: "removeSelectedProduct",
		value: function removeSelectedProduct(sku) {
			var selectedProducts = this.state.selectedProducts;
			var ret_first = void 0;
			var ret_second = void 0;
			if (selectedProducts.indexOf(sku) >= -1) {
				ret_first = selectedProducts.slice(0, selectedProducts.indexOf(sku));
				ret_second = selectedProducts.slice(selectedProducts.indexOf(sku) + 1, selectedProducts.length + 1);
			}
			this.setSelectedProducts(ret_first.concat(ret_second));
		}
	}, {
		key: "setSelectedProducts",
		value: function setSelectedProducts(sku_list) {
			var _this3 = this;

			Promise.resolve(this.setState({
				selectedProducts: sku_list
			})).then(function () {
				_this3.triggerOnChange();
			});
		}
	}, {
		key: "getSelectedProducts",
		value: function getSelectedProducts() {
			return this.state.selectedProducts;
		}
	}, {
		key: "setCuttedProducts",
		value: function setCuttedProducts(sku_list) {
			var _this4 = this;

			Promise.resolve(this.setState({
				cuttedProducts: sku_list
			})).then(function () {
				_this4.triggerOnChange();
			});
		}
	}, {
		key: "getCuttedProducts",
		value: function getCuttedProducts() {
			return this.state.cuttedProducts;
		}
	}, {
		key: "setOnContextMenuProduct",
		value: function setOnContextMenuProduct(sku) {
			var _this5 = this;

			Promise.resolve(this.setState({
				onContextMenuProduct: sku
			})).then(function () {
				_this5.triggerOnChange();
			});
		}
	}, {
		key: "getOnContextMenuProduct",
		value: function getOnContextMenuProduct() {
			return this.state.onContextMenuProduct;
		}
	}, {
		key: "triggerOnChange",
		value: function triggerOnChange() {
			if (this.props.onChange != null) {
				this.props.onChange(this.state);
			}
		}
	}, {
		key: "componentWillMount",
		value: function componentWillMount() {
			var debug_val = Object.assign({}, this.getDefaults(), {
				"SKIP": 0
			}, this.props.preferences(), this.props.additionalDefaults());
			this.callLoader(debug_val);
		}
	}, {
		key: "callLoader",
		value: function callLoader(options) {
			// springe zurück zu header
			window.scrollTo(0, 0);

			//Reihenfolge wichtig additionalDefaults() muss zuerst augerufen werden
			var newOptions = Object.assign(this.props.additionalDefaults(), options);
			delete newOptions.MAX_HIT;
			delete newOptions.PRODUCTS;
			this.setSelectedProducts([]);
			return this.props.loader(newOptions);
		}
	}, {
		key: "fullNextPropsReload",
		value: function fullNextPropsReload(nextProps) {
			var defaults = Object.assign(this.getDefaults(), {
				SKIP: 0
			}, this.props.additionalDefaults(nextProps));
			this.callLoader(defaults);
		}
	}, {
		key: "getDefaults",
		value: function getDefaults() {
			var pmv = this.props.productsMultipleView[this.props.view];
			return Object.assign({
				SKIP: 0,
				LIMIT: 20,
				SORT: { SKU: -1 },
				FILTER_CLASS: "LIST",
				VIEW: this.props.view
			}, pmv == null ? {} : pmv.data);
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			var shouldFullNextPropsReload = this.props.shouldFullNextPropsReload(this.props, nextProps);
			if (shouldFullNextPropsReload) {
				this.fullNextPropsReload(nextProps);
			}
		}
	}, {
		key: "moveSkip",
		value: function moveSkip(newSkip) {
			var defaults = this.getDefaults();
			if (newSkip < 0) newSkip = 0;
			if (newSkip == defaults.SKIP || newSkip > defaults.MAX_HIT) return;
			this.callLoader(Object.assign(defaults, { SKIP: newSkip }));
		}
	}, {
		key: "getRange",
		value: function getRange(pmv) {
			var data = pmv.data;

			var from = "";
			var to = "";

			if (data != null) {

				from = data.SKIP + 1;
				to = data.SKIP + data.LIMIT;
				if (to > data.MAX_HIT) to = data.MAX_HIT;
			}
			if (data.MAX_HIT == 0) {
				from = 0;
			}
			return from + " - " + to;
		}
	}, {
		key: "getMaxHit",
		value: function getMaxHit(pmv) {
			var data = pmv.data;
			var max_hit = "";
			if (data != null) {
				max_hit = data.MAX_HIT;
			}
			return max_hit;
		}
	}, {
		key: "handleForwardClick",
		value: function handleForwardClick() {
			var defaults = this.getDefaults();
			var newSkip = defaults.SKIP + defaults.LIMIT;
			this.moveSkip(newSkip);
		}
	}, {
		key: "handleEndClick",
		value: function handleEndClick() {
			var defaults = this.getDefaults();
			var newSkip = Math.floor(defaults.MAX_HIT / defaults.LIMIT) * defaults.LIMIT;
			this.moveSkip(newSkip);
		}
	}, {
		key: "handleBeginningClick",
		value: function handleBeginningClick() {
			this.moveSkip(0);
		}
	}, {
		key: "handleBackwardClick",
		value: function handleBackwardClick() {
			var defaults = this.getDefaults();
			if (defaults.SKIP) this.callLoader(Object.assign(defaults, { SKIP: defaults.SKIP - defaults.LIMIT }));
		}
	}, {
		key: "handleFilterClassClick",
		value: function handleFilterClassClick(filterClass) {
			var _this6 = this;

			this.props.changePreferences({
				PMV_FILTER_CLASS: filterClass
			}).then(function () {
				_this6.callLoader(Object.assign(_this6.getDefaults(), { FILTER_CLASS: filterClass }));
			});
		}
	}, {
		key: "handlePageEnter",
		value: function handlePageEnter(val) {
			var defaults = this.getDefaults();
			var newSkip = (parseInt(val) - 1) * defaults.LIMIT;
			this.moveSkip(newSkip);
		}
	}, {
		key: "handleLimitChange",
		value: function handleLimitChange(val) {
			var intVal = parseInt(val);
			var defaults = this.getDefaults();
			defaults.LIMIT = intVal;
			var newSkip = defaults.SKIP;
			var page = Math.floor(newSkip / intVal);
			defaults.SKIP = page * intVal;

			this.props.changePreferences({
				PMV_LIMIT: defaults.LIMIT
			});

			this.callLoader(Object.assign(defaults, {
				LIMIT: defaults.LIMIT,
				SKIP: defaults.SKIP
			}));
		}
	}, {
		key: "handleSortChange",
		value: function handleSortChange(val) {
			var defaults = this.getDefaults();
			var newSort = defaults.SORT;

			var sortOptions = this.props.sortOptions;
			if (sortOptions[val] != undefined) {
				newSort = sortOptions[val].sort;
			}
			this.callLoader(Object.assign(defaults, { SKIP: 0, SORT: newSort }));
		}
	}, {
		key: "renderEmptyResultComponent",
		value: function renderEmptyResultComponent(pmv) {
			return _react2.default.createElement(
				"div",
				{ className: "ProductsMultipleView" },
				this.props.showNavbarIfEmptyResult ? this.renderListHeader(pmv) : "",
				_react2.default.createElement(
					_reactBootstrap.Row,
					{ className: "CategoryProduct" },
					pmv.loading ? this.renderLoading() : this.props.emptyResultComponent()
				)
			);
		}
	}, {
		key: "renderLoading",
		value: function renderLoading() {
			return _react2.default.createElement(
				_reactLayoutComponents.Box,
				{ column: true, fit: true },
				_react2.default.createElement(
					_reactLayoutComponents.Box,
					{ center: true },
					_react2.default.createElement(_reactToolbox.ThreeBounce, null)
				)
			);
		}
	}, {
		key: "renderProducts",
		value: function renderProducts(pmv) {
			var data = pmv.data;
			var filter = this.props.filterClasses;
			var componentCallback = filter[data.FILTER_CLASS] != undefined ? filter[data.FILTER_CLASS].tag : null;

			return data.PRODUCTS.map(function (sku) {
				return componentCallback(sku);
			});
		}
	}, {
		key: "renderHits",
		value: function renderHits(pmv) {
			return _react2.default.createElement(
				"div",
				{ className: "list-header-item" },
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-label" },
					_react2.default.createElement(
						"span",
						null,
						_react2.default.createElement(_translate.Tr, { path: "products.Hits",
							format: { AMOUNT: this.getRange(pmv), MAXHITS: this.getMaxHit(pmv) } })
					)
				)
			);
		}
	}, {
		key: "renderListHeader",
		value: function renderListHeader(pmv) {
			return _react2.default.createElement(
				_reactBootstrap.Row,
				{ className: "ListHeader" },
				_react2.default.createElement(
					_reactStickyEl2.default,
					null,
					_react2.default.createElement(
						"div",
						{ className: "list-header-row" },
						_react2.default.createElement(
							_reactToolbox.ResponsiveRender,
							{ xs: true },
							this.renderHitsPerPage(pmv),
							this.renderSortSelect(pmv)
						),
						_react2.default.createElement(
							_reactToolbox.ResponsiveRender,
							{ sm: true, md: true, lg: true },
							this.renderHits(pmv),
							this.renderSortSelect(pmv),
							this.renderHitsPerPage(pmv),
							this.renderFilterClass(pmv)
						)
					),
					this.props.tableHeaderComponent()
				),
				_react2.default.createElement(
					_reactBootstrap.Col,
					{ xs: 12 },
					_react2.default.createElement("hr", null)
				)
			);
		}
	}, {
		key: "renderListFooter",
		value: function renderListFooter(pmv) {
			return _react2.default.createElement(
				_reactBootstrap.Row,
				{ className: "ListFooter" },
				_react2.default.createElement(
					"div",
					{ className: "list-footer-row" },
					this.renderPagination(pmv)
				)
			);
		}
	}, {
		key: "renderAvailabilityFilter",
		value: function renderAvailabilityFilter(pmv) {
			var enabled = pmv.data != null && !pmv.loading;
			return _react2.default.createElement(
				"div",
				{ className: "list-header-item" },
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-label" },
					_react2.default.createElement(_translate.Tr, { path: "products.Filter.AvailableOnly.Label" })
				),
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-input" },
					_react2.default.createElement(_forms.ESInput.Toggle, {
						fieldName: "SHOW_UNAVAILABLE",
						trOn: "products.Filter.AvailableOnly.On",
						trOff: "products.Filter.AvailableOnly.Off",
						disabled: !enabled,
						bsSize: "sm"
					})
				)
			);
		}
	}, {
		key: "renderSortSelect",
		value: function renderSortSelect(pmv) {
			var enabled = pmv.data != null && !pmv.loading;

			var options = [];
			Object.values(this.props.sortOptions).map(function (v) {
				options.push({
					value: v["value"],
					textTr: v["textTr"]
				});
			});

			return _react2.default.createElement(
				"div",
				{ className: "list-header-item" },
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-label" },
					_react2.default.createElement(_translate.Tr, { path: "products.Sort.Sortby" })
				),
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-input" },
					_react2.default.createElement(_forms.ESInput.Select, {
						// trLabel={"products.Filter.Sort.Sortby"}
						fieldName: "sortOrder",
						options: options,
						value: this.props.defaultSortValue,
						ignoreValue: true,
						sortEntries: false,
						onFocus: function onFocus() {},
						onChange: this.handleSortChange.bind(this),
						disabled: !enabled,
						bsSize: "sm"
					})
				)
			);
		}
	}, {
		key: "renderFilterClass",
		value: function renderFilterClass(pmv) {
			var _this7 = this;

			if (Object.keys(this.props.filterClasses).length <= 1) {
				return null;
			}
			var data = pmv.data;
			var enabled = pmv.data != null && !pmv.loading;

			// let gcn = classnames({'btn-primary': data != null && data.FILTER_CLASS == 'GRID'});
			// let lcn = classnames({'btn-primary': data != null && data.FILTER_CLASS == 'LIST'});


			var filterButtons = [];
			Object.entries(this.props.filterClasses).map(function (v) {
				var filter = v[0];
				var item = v[1];
				var Icon = v[1]["icon"];

				filterButtons.push(_react2.default.createElement(
					_reactBootstrap.Button,
					{
						className: { "btn-primary": data != null && data.FILTER_CLASS == filter },
						onClick: _this7.handleFilterClassClick.bind(_this7, filter),
						disabled: !enabled,
						bsSize: "sm",
						key: filter
					},
					_react2.default.createElement(_reactToolbox.InlineIcon, { icon: Icon, noMargin: true })
				));
			});

			return _react2.default.createElement(
				"div",
				{ className: "list-header-item" },
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-label" },
					_react2.default.createElement(_translate.Tr, { path: "products.View" })
				),
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-input" },
					_react2.default.createElement(
						"div",
						{ className: "FilterClass" },
						filterButtons
					)
				)
			);
		}
	}, {
		key: "renderPagination",
		value: function renderPagination(pmv) {
			var data = pmv.data;
			var bwe = false;
			var fwe = false;
			var numberOfPages = null;
			var page = "";
			var enabled = pmv.data != null && !pmv.loading;
			if (data != null) {
				if (!pmv.loading) {
					bwe = data.SKIP > 0;
					fwe = data.SKIP + data.LIMIT < data.MAX_HIT;
				}
				numberOfPages = Math.ceil(data.MAX_HIT / data.LIMIT);
				page = data.SKIP / data.LIMIT + 1;
			}
			if (numberOfPages == 0) {
				numberOfPages = 1;
			}
			return _react2.default.createElement(
				"div",
				{ className: "list-footer-item" },
				_react2.default.createElement(
					"div",
					{ className: "list-footer-item-input" },
					_react2.default.createElement(
						"div",
						{ className: "Pagination" },
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ onClick: this.handleBeginningClick.bind(this),
								disabled: !bwe
							},
							_react2.default.createElement(_reactToolbox.InlineIcon, { icon: _PageFirstIcon2.default })
						),
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ onClick: this.handleBackwardClick.bind(this),
								disabled: !bwe
							},
							_react2.default.createElement(_reactToolbox.InlineIcon, { icon: _ChevronLeftIcon2.default })
						),
						_react2.default.createElement(
							"div",
							{ className: "pagination-input" },
							_react2.default.createElement(_forms.ESInput.Number, {
								value: page,
								decimals: 0,
								onFocus: function onFocus() {},
								suffix: "&nbsp;/&nbsp;" + numberOfPages
								// prefix={"&nbsp;/&nbsp;"}
								, min: 1,
								max: numberOfPages,
								step: 1,
								onEnter: this.handlePageEnter.bind(this),
								noWheel: true,
								disabled: !enabled
							})
						),
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ onClick: this.handleForwardClick.bind(this),
								disabled: !fwe
							},
							_react2.default.createElement(_reactToolbox.InlineIcon, { icon: _ChevronRightIcon2.default })
						),
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ onClick: this.handleEndClick.bind(this),
								disabled: !fwe
							},
							_react2.default.createElement(_reactToolbox.InlineIcon, { icon: _PageLastIcon2.default })
						)
					)
				)
			);
		}
	}, {
		key: "renderHitsPerPage",
		value: function renderHitsPerPage(pmv) {
			var data = pmv.data;
			var val = "";
			var enabled = pmv.data != null && !pmv.loading;
			if (data != null) {
				val = data.LIMIT.toString();
			}
			// console.log("renderHitsPerPage", val);

			return _react2.default.createElement(
				"div",
				{ className: "list-header-item" },
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-label" },
					_react2.default.createElement(_translate.Tr, { path: "products.VisibleProductCount" })
				),
				_react2.default.createElement(
					"div",
					{ className: "list-header-item-input" },
					_react2.default.createElement(_forms.ESInput.Select, {
						fieldName: "PMV_LIMIT",
						options: [{ value: "20", text: "20" }, { value: "50", text: "50" }, { value: "100", text: "100" }],
						sortEntries: false,
						onFocus: function onFocus() {},
						onChange: this.handleLimitChange.bind(this),
						bsSize: "small",
						value: val,
						disabled: !enabled
					})
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			//
			var pmv = this.props.productsMultipleView[this.props.view];
			if (pmv == null) return null;
			if (pmv.data == null && !pmv.loading) return null;
			if (pmv.data == null && pmv.loading) return this.renderLoading();
			if (pmv.data.MAX_HIT === 0) return this.renderEmptyResultComponent(pmv);

			return _react2.default.createElement(
				"div",
				{ className: "ProductsMultipleView", id: "anchor_scroll_top" },
				this.renderListHeader(pmv),
				_react2.default.createElement(
					_reactBootstrap.Row,
					{ className: "CategoryProduct"
					},
					_react2.default.createElement(
						"div",
						{
							id: "products"
						},
						pmv.loading ? this.renderLoading() : this.renderProducts(pmv)
					),
					this.props.tableFooterComponent()
				),
				pmv.loading ? null : this.renderListFooter(pmv)
			);
		}
	}]);

	return ProductsMultipleView;
}(_react2.default.Component), _class2.defaultProps = {
	view: "defaultMultipleView",
	preferences: function preferences() {
		return {
			LIMIT: 20,
			FILTER_CLASS: "LIST"
		};
	},
	additionalDefaults: function additionalDefaults() {},
	loader: function loader() {},
	filterClasses: {
		LIST: {
			tag: ESDBProductPlaceHolder,
			icon: _ViewListIcon2.default
		},
		GRID: {
			tag: ESDBProductPlaceHolder,
			icon: _GridIcon2.default
		}
	},

	shouldFullNextPropsReload: function shouldFullNextPropsReload() {},
	changePreferences: function changePreferences() {},
	sortOptions: {
		newest_down: {
			value: "newest_down",
			textTr: "products.Sort.Created.Descending",
			sort: { SKU: -1 }
		}
	},
	emptyResultComponent: function emptyResultComponent() {},
	showNavbarIfEmptyResult: true,
	tableHeaderComponent: function tableHeaderComponent() {},
	tableFooterComponent: function tableFooterComponent() {},
	defaultSortValue: "newest_down"

}, _class2.propTypes = {
	view: _propTypes2.default.string,
	preferences: _propTypes2.default.any,
	additionalDefaults: _propTypes2.default.any,
	loader: _propTypes2.default.any,
	filterClasses: _propTypes2.default.any,
	shouldFullNextPropsReload: _propTypes2.default.any,
	changePreferences: _propTypes2.default.any,
	sortOptions: _propTypes2.default.any,
	emptyResultComponent: _propTypes2.default.any,
	showNavbarIfEmptyResult: _propTypes2.default.bool,
	tableHeaderComponent: _propTypes2.default.any,
	tableFooterComponent: _propTypes2.default.any,
	onChange: _propTypes2.default.func,
	defaultSortValue: _propTypes2.default.string

}, _temp)) || _class);


ProductsMultipleView.registerTranslation = function () {
	return (0, _translate.translation_register)("products", _trProductsMultipleView.trProductsMultipleView);
};